import React, { useContext, useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { AppContexts } from "../../../providers";
import surveysService from "../../../services/surveys.service";
import SurveyPreviewForm from "../SurveyPreviewForm";
import { resolveGuestbookTheme, contrastRatio } from "../guestbook-theme";
import "./preview.css";

const SurveyPreview = () => {
  const { get, settings } = useContext(AppContexts.SettingsContext);
  const history = useHistory();
  const getBranding = useRef(get);
  const surveyId = history.location.pathname.split("/")[2];
  const [survey, setSurvey] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    document.title = "Preview Survey - RueBaRue";
    const navbar = document.getElementById("ruebarue-navbar");
    const wasHidden = navbar?.hidden;
    if (navbar) navbar.hidden = true;
    getBranding.current(["branding", "guestbook"]);
    setSurvey(null); setError("");
    surveysService.getSurveyById(surveyId).then(({ data }) => {
      if (active) data ? setSurvey(data) : setError("Survey not found.");
    }).catch(() => { if (active) setError("Unable to load the survey. Please reload and try again."); });
    return () => { active = false; if (navbar) navbar.hidden = wasHidden; };
  }, [surveyId]);
  const theme = resolveGuestbookTheme(settings.guestbook || {});
  const branding = settings.branding || {};
  const accent = theme.active_tab_color || theme.distance_color || branding.color_2 || "#303544";
  const text = theme.tab_text_color;
  const accentText = text && contrastRatio(accent, text) >= 4.5 ? text : contrastRatio(accent, "#ffffff") >= 4.5 ? "#ffffff" : "#111827";
  const logo = branding.logo_image_url || branding.logo_url;
  return <main id="surveys-preview-template" className="guest-survey-preview" style={{
    "--preview-accent": accent, "--preview-accent-text": accentText,
    "--preview-background": theme.page_background_color || branding.color_4 || "#f7f8fa",
    "--preview-surface": theme.block_background_color || "#ffffff",
  }}>
    <div className="survey-preview-container">
      {logo ? <img className="survey-preview-logo" src={logo} alt={branding.company_name || "Host logo"} /> : branding.company_name && <p className="survey-preview-company">{branding.company_name}</p>}
      {error ? <p role="alert" className="uk-text-danger">{error}</p> : !survey ? <p role="status">Loading survey…</p> : <>
        <header className="survey-preview-header"><h1>{survey.name}</h1>{survey.intro && <p style={{ whiteSpace: "pre-wrap" }}>{survey.intro}</p>}</header>
        <SurveyPreviewForm key={surveyId} survey={survey} />
      </>}
    </div>
  </main>;
};
export default SurveyPreview;
